// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"e8416e0c","38":"7c6ada7e","177":"88418446","249":"05e15009","367":"ccfe2370","462":"f344a14c","529":"58b0271e","532":"c22997a5","535":"d04332a2","571":"f65deedb","641":"7b396f7d","705":"0fb00d5e","718":"7691889a","756":"348b755c","882":"f163c566"}[chunkId] + ".chunk.js";
};